import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EvidVidTypeService} from './services/evid-vid-type.service';
import {EvidRevisionService} from "@catmodels/evid/services/evid-revision.service";

const publicComponents = [];

const imports = [
  CommonModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [
  EvidVidTypeService,
  EvidRevisionService,
];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class EvidModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/evid/evid.module.ts